import { Box, Typography } from '@mui/material';
import React from 'react';
import { SparkDialog } from 'sharedComponents/UI';
import AddWorkspaceDialogContent from './AddWorkspaceDialogContent';

type AddWorkspaceDialogProps = {
  open: boolean;
  onClose: () => void;
};

function AddWorkspaceDialog({ open, onClose }: AddWorkspaceDialogProps) {
  return (
    <SparkDialog
      title={
        <Box display='flex' gap={2} alignItems='center'>
          <Typography marginBottom={-0.5} variant='h5'>
            Add Workspace
          </Typography>
        </Box>
      }
      open={open}
      onClose={onClose}
      disableBackdropClick={false}
    >
      <AddWorkspaceDialogContent />
    </SparkDialog>
  );
}

export default AddWorkspaceDialog;
